// extracted by mini-css-extract-plugin
export default {"sns_login":"SnsLogin_sns_login__YbnKS","sns_icon":"SnsLogin_sns_icon__GXpec"};